export default __webpack_public_path__ + "static/jisvicente_logo-401ee92d9e2b8bd2d8e516d7a79e936b.png";